import React from "react";
import { paymentTypeLabel } from "../../constants/transactionLabels";
import "./PurposeBadge.css";
const purposes = ["transfer", "booking", "topup", "wallet_topup", "checkout", "shipment", "order", "shopforme", "fx", "vtu", "shipment_adjustment", "carts", "amazon_shop", "naija_shop"];
export default function PurposeBadge({ value }: { value?: string }) {
  const key = value?.toLowerCase() || "";
  return <span className={`navo-purpose navo-purpose--${purposes.includes(key) ? key : "other"}`}>{paymentTypeLabel(value)}</span>;
}
